import { render, staticRenderFns } from "./AllStudentsView.vue?vue&type=template&id=6d550636&scoped=true&"
import script from "./AllStudentsView.vue?vue&type=script&lang=ts&"
export * from "./AllStudentsView.vue?vue&type=script&lang=ts&"
import style0 from "./AllStudentsView.vue?vue&type=style&index=0&id=6d550636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d550636",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTextField})
